<template>
  <div class="jumbotron">
    <loading :active.sync="loading"></loading>
    <div>
      <div class="row">
        <h4>Order Summary</h4>
      </div>
      <div class="row">
        <div class="col">
          <p>Package: <span class="product">{{ getProduct.charAt(0).toUpperCase() + getProduct.slice(1) }}</span></p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <p>Once you check out you can edit your service specialties in your profile.</p>
        </div>
      </div>
      <div class="row row-margin">
        <div class="col">
          <p>Zip Codes:</p>
          <button class="btn btn-secondary" v-for="zip in getZips" v-bind:key="zip.id">{{ zip }}</button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <h5>Total Monthly Cost: <span class="product">${{ cost }}</span></h5>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <h4>Payment Information</h4>
          <div v-if="cost !== 'Enterprise'" id="dropin-container"></div>
          <div v-else>
            <p>Please call us at (612) 655-2324 for pricing information.</p>
          </div>
          <!--
          <p>Card number: 4111 1111 1111 1111</p>
          <p>Expiry: 09/20</p>
          <p>CVV: 400</p>
          -->
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <b-alert variant="danger"
               dismissible
               :show="showDismissibleAlert"
               @dismissed="showDismissibleAlert=false">
            An error has occured please try again later.
          </b-alert>
        </div>
      </div>
      <div class="row needs-padding">
        <div class="col-6">
          <b-button to="/profile/business/advertising/priority/specialties" class="btn btn-secondary" id="back-button">Back</b-button>
        </div>
        <div class="col-6">
          <button v-if="cost !== 'Enterprise'" v-on:click='checkout' class="btn btn-primary">Process Payment</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  components: {
    Loading
  },
  data () {
    return {
      instance: null,
      cost: null,
      loading: false,
      showDismissibleAlert: false
    }
  },
  computed: {
    ...mapGetters('products', [
      'getZips',
      'getProduct'
    ]),
    ...mapGetters('business', [
      'getAreasServiced'
    ])
  },
  methods: {
    ...mapActions('business', [
      'getBtToken'
    ]),
    ...mapMutations('products', [
      'updateProduct',
      'updateZips'
    ]),
    ...mapMutations('business', [
      'updateHasAdvertisingPlan'
    ]),
    ...mapActions('products', [
      'getPrice',
      'getPriorityAdvertisingPlan'
    ]),
    async checkPrice () {
      this.cost = await this.getPrice()
    },
    async checkout () {
      this.loading = true
      var that = this
      this.instance.requestPaymentMethod(async (err, payload) => {
        if (err) {
          console.log(err)
          this.loading = false
          return
        }
        var client = this.$store.getters.getPaymentApigClientFactory
        var params = {}
        var pathTemplate = '/businesses/payments'
        var method = 'POST'
        var additionalParams = {}
        var body = {
          payment_method_nonce: payload.nonce,
          advertising: {
            'tier_pricing': that.getProduct,
            'zips': that.getZips
          }
        }
        try {
          // Create advertising plan subscription
          await client.invokeApi(params, pathTemplate, method, additionalParams, body)
          // Retrieve details of plan
          await that.getPriorityAdvertisingPlan()
          that.loading = false
          // Redirect to overview page
          that.updateHasAdvertisingPlan(true)
          that.$router.push('/profile/business/advertising')
        } catch (error) {
          that.loading = false
          that.showDismissibleAlert = true
          console.log(error)
        }
      })
    },
    async showPayment () {
      try {
        var clientToken = await this.getBtToken()
        this.instance = await window.braintree.dropin.create({
          authorization: clientToken,
          container: '#dropin-container'
        })
      } catch (error) {
        console.log(error)
        this.showDismissibleAlert = true
      }
    }
  },
  created () {
    if (!this.getProduct) {
      this.updateProduct('basic')
    }
    if (this.getZips.length === 0) {
      this.updateZips(JSON.parse(JSON.stringify(this.getAreasServiced)))
    }
  },
  async mounted () {
    this.loading = true
    await this.checkPrice()
    if (this.cost !== 'Enterprise') await this.showPayment()
    this.loading = false
  }
}
</script>

<style scoped>
.needs-padding {
  padding-top: 1rem;
}

input {
  width: 100%;
}

.row-margin {
  margin-bottom: 1rem;
}

.form-row-padding {
  padding-bottom: 2rem;
}

.no-margin-bottom {
  margin-bottom: 0px;
}

#back-button {
  width: 100%;
}

.homapt-padding-bottom {
  padding-bottom: 2rem;
}

.top-row-padding {
  padding-bottom: 1rem;
}

.btn-secondary {
  margin: .5rem;
}

.grayout {
  background-color: gray !important;
  color: black !important;
  cursor: unset !important;
}

@media (max-width: 768px) {
  .text-right {
    text-align: left !important;
    padding-left: 1rem;
  }
}

.jumbotron {
  background-color: #f1f1f1 !important;
  margin-bottom: 3rem !important;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.btn {
  margin-top: 0px !important;
}

.product {
  padding-top: .5rem;
  padding-bottom: .5rem;
  padding-left: 2rem;
  padding-right: 2rem;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/businessProfile/advertising/priority/subnavItems/Checkout.vue